module.exports = __webpack_public_path__ + "img/selected6-min.fe5b3260.png";